import React from 'react'
import { Badge } from '@/components/ui/badge'
import Timeago from '../../../../../timeago'

class TutorResultWarningsPartial extends React.Component {

  render() {
    return (
      <div className="rounded-[10px] border border-border bg-card px-4 py-3">
        <div className="flex items-center gap-1 text-sm font-semibold">
          {this.props.tutor_warning.severity ?
            <span className="uppercase">{this.props.tutor_warning.severity}</span>
            : null
          }
          <Timeago date={this.props.tutor_warning.incident_at}/>
          <span className="ml-auto font-normal text-muted-foreground">Issued By: {this.props.tutor_warning.issued_by}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {this.props.tutor_warning.reasons.map((reason) =>
            <Badge variant="warning" className="capitalize" key={reason}>{reason}</Badge>
          )}
        </div>
        <div className="mt-2">
          {this.props.tutor_warning.note}
        </div>
      </div>
    )
  }
}

export default TutorResultWarningsPartial
